import React from 'react';
import { Link } from 'react-router-dom';
import {
  CookbookTag,
  useTranslator,
  cloudflareImage,
  useAppContext,
} from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

interface IMealTypeTag extends CookbookTag {
  dietTypeTagId: number;
  dietTypeName: string;
}
const MealTypeTag: React.FC<IMealTypeTag> = ({
  dietTypeTagId,
  id,
  name,
  imageUrl,
  mealsCount,
  dietTypeName,
}) => {
  const { t } = useTranslator();

  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();

  const coverImageLarge = cloudflareImage(imageUrl, `${APP_BRAND}`, 'cookbookMealTypeTagLarge');
  const coverImageSmall = cloudflareImage(imageUrl, `${APP_BRAND}`, 'cookbookMealTypeTagSmall');

  return (
    <div className="cookbook-tag-item">
      <Link
        to={`/meals/cookbook/tag/${dietTypeTagId}/${id}`}
        onClick={() => {
          trackFirebaseEvent('user_action', {
            action: 'tap-all_recipes',
            locatgion: 'Cookbook_meal_type',
            cookbook_meal_type: name,
            selected_diet: dietTypeTagId,
            meals_tab: 'cookbook',
          });
        }}
      >
        <img
          src={coverImageLarge}
          width={1028}
          height={160}
          className="img-fluid d-none d-md-block placeholder"
          onLoad={(e) => {
            const img = e.currentTarget;
            img.classList.remove('placeholder');
          }}
          alt={name}
        />
        <img
          src={coverImageSmall}
          width={636}
          height={256}
          className="img-fluid d-md-none placeholder"
          onLoad={(e) => {
            const img = e.currentTarget;
            img.classList.remove('placeholder');
          }}
          alt={name}
        />
        <div className="text-center">
          <p className="small white mb-2">{dietTypeName}</p>
          <h2 className="title-medium semi-bold white mb-2">{name}</h2>
          <p className="small white mb-0">
            {mealsCount} {t('cookbook.mealCategoryThumb.quantityRecipe', { count: mealsCount })}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default MealTypeTag;
